const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaFornecedor: [],
	listaEmbalagem: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'FORNECEDOR_EMBALAGEM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'FORNECEDOR_EMBALAGEM_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'FORNECEDOR_EMBALAGEM_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'FORNECEDOR_EMBALAGEM_FORNECEDOR_SELECT_LISTADO':
			return {
				...state,
				listaFornecedor: action.payload.data
			};

        case 'FORNECEDOR_EMBALAGEM_EMBALAGEM_SELECT_LISTADO':
			return {
				...state,
				listaEmbalagem: action.payload.data
			};

        default:
            return state;
    }
}
